var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"input-value":_vm.isTankFieldsShown,"label":"Show additional tank columns"},on:{"change":_vm.setTankFields}})}
var staticRenderFns = []

export { render, staticRenderFns }